<template>
    <v-container fluid>
        <h1>Benutzerverwaltung</h1>
    </v-container>
</template>

<script>
export default {
  name: 'AlarmSummary',
  data () {
    return {
      'demo': '12'
    }
  },
}
</script>

<style>

</style>
